/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { RichText } from "cms/rich-text";
import { useScrollToLocation } from "cms/hooks/use-scroll-to-location";
import { defaultTOCRichTextObjectPM } from "cms/shared/toc/default_toc_rich_text";
import { useFetchTableOfContents } from "./use-fetch-table-of-contents";

const TableOfContents = (props) => {

    const richtext = props?.richtext ?? defaultTOCRichTextObjectPM;

    // a utility to scroll on load, to anchors based on hash params in the URL
    useScrollToLocation();

    // Get chapters
    const { chapters, loading } = useFetchTableOfContents();

    return (
        <>
            {chapters && !loading &&
                <>
                    <div id='top' className='toc-top-target' />
                    <div className='table-of-contents'>
                        <RichText richtext={richtext} />
                        {chapters && chapters.map((item, index) => {
                            const chapter = item?.chapter;
                            const target = item?.target;

                            return (
                                <li key={`${target}${index}`}>
                                    <a href={`#${target}`}>{chapter}</a>
                                </li>
                            );
                        })}
                    </div>
                </>
            }
        </>
    );
};

TableOfContents.displayName = "TableOfContents";
export { TableOfContents };
